module.exports = __webpack_public_path__ + "media/styles/images/png/baruch-logo-e8265907833b846194f47458198f5da8.png";